import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "account-order" }
const _hoisted_2 = { class: "account-order__container" }
const _hoisted_3 = {
  key: 0,
  class: "loader"
}
const _hoisted_4 = {
  key: 1,
  class: "account-order__list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "account-order__item-left" }
const _hoisted_7 = { class: "account-order__item-left-container" }
const _hoisted_8 = { class: "account-order__item-title" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.4 18L8 16.6L12.6 12L8 7.4L9.4 6L15.4 12L9.4 18Z",
      fill: "#A8A8A8"
    })
  ])
], -1)
const _hoisted_10 = { class: "account-order__item-date" }
const _hoisted_11 = { class: "account-order__item-tovar" }
const _hoisted_12 = { class: "account-order__item-tovar-count" }
const _hoisted_13 = { class: "account-order__item-tovar-price" }
const _hoisted_14 = { class: "account-order__item-middle" }
const _hoisted_15 = { class: "account-order__item-middle-list" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "account-order__item-middle-item-length"
}
const _hoisted_19 = { class: "account-order__item-right" }
const _hoisted_20 = { class: "account-order__item-status account-order__item-status--white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id,
                class: "account-order__item",
                onClick: ($event: any) => (_ctx.orderDetail(item))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", null, "№" + _toDisplayString(item.id), 1),
                      _hoisted_9
                    ]),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatDate(new Date(item.createdDate))), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(item.basket.items.length) + " товар" + _toDisplayString(_ctx.declOfNum(item.basket.items.length, ["", "а", "ов"])) + " • ", 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.priceFormat(item.price)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("ul", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.basket.items, (img, index) => {
                        return _withDirectives((_openBlock(), _createElementBlock("li", {
                          class: "account-order__item-middle-item",
                          key: img.id
                        }, [
                          (img.images[0])
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: img.images[0],
                                alt: "Фото товара"
                              }, null, 8, _hoisted_16))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: require('@/assets/img/no-photo-history.svg'),
                                alt: ""
                              }, null, 8, _hoisted_17))
                        ])), [
                          [_vShow, index < 3]
                        ])
                      }), 128))
                    ]),
                    (item.basket.items.length > 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, " + " + _toDisplayString(item.basket.items.length - 3), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(item.status.name), 1)
                ])
              ], 8, _hoisted_5))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}